import { render, staticRenderFns } from "./SelectData.vue?vue&type=template&id=036cf24f"
import script from "./SelectData.vue?vue&type=script&lang=js"
export * from "./SelectData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036cf24f')) {
      api.createRecord('036cf24f', component.options)
    } else {
      api.reload('036cf24f', component.options)
    }
    module.hot.accept("./SelectData.vue?vue&type=template&id=036cf24f", function () {
      api.rerender('036cf24f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectData/SelectData.vue"
export default component.exports